import React from 'react'
import styled, { css } from 'styled-components'
import find from 'lodash/find'
import { styles, utils } from 'gipsy-misc'
import { UserPicture, Tooltip, Icon } from 'gipsy-ui'
import variables from 'assets/styles/variables'

const Watchers = ({ watchers, pulsate }) => {
  const toDisplayValues = utils.watchers.sortReviewerFirst(watchers).reverse()
  const n = toDisplayValues.length
  const hasReviewer = !!find(watchers, ['isReviewer', true])

  return (
    <WatcherContainer className="watcher-container" style={{ width: `${(n + 1) * 14}px` }}>
      {toDisplayValues.map((user, i) => (
        <PictureTooltip
          className="picture-tooltip"
          key={utils.user.getKey(user)}
          style={i === 0 ? { left: (n - i - 1) * 14 } : { left: (n - i - 1) * 14, position: 'absolute' }}>
          <Pulsate className="pulsate" pulsate={pulsate}>
            <UserPicture size={28} border={`3px solid ${variables.bodyBackgroundColor}`} src={user.picture} alt="" />
          </Pulsate>
          <Tooltip text={user.displayName || user.email || 'Unknown'} vs={30} hs={20} position="top left" />
          {hasReviewer && i === toDisplayValues.length - 1 && (
            <Star className="star-icon" icon="Star" fill={styles.colors.primaryColor} size={10} />
          )}
        </PictureTooltip>
      ))}
    </WatcherContainer>
  )
}
export default Watchers

const WatcherContainer = styled.span`
  position: relative;
  height: 28px;
`

const PictureTooltip = styled.div`
  position: relative;
  float: right;
`

const Star = styled(Icon)`
  &&& {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: ${variables.bodyBackgroundColor};
    padding: 3px;
    border-radius: 50%;
    box-sizing: content-box;
  }
`

const Pulsate = styled.div`
  @keyframes flickerAnimation {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  ${props =>
    props.pulsate &&
    css`
      animation: flickerAnimation 2s infinite;
    `}
`



// WEBPACK FOOTER //
// ./src/features/list/components/line/components/Watchers.js